import { PageAttr } from "../../../domain/entities/fetch-entities";
import { useMemo } from "react";

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function useConcatPages<T>(pages: Array<PageAttr<T>>): Array<T> {
  return useMemo<Array<T>>(
    () =>
      pages.reduce<Array<T>>(
        (prev, page) => [...prev, ...page.data],
        [] as Array<T>
      ),
    [pages]
  );
}

export { useConcatPages };
